/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BusinessPermission = {
    BILLING: 'BILLING',
    USERS: 'USERS',
    MENUS: 'MENUS',
    CONTACT: 'CONTACT',
    ORDERS_VIEW: 'ORDERS_VIEW',
    OPERATIONS: 'OPERATIONS'
} as const;
export type BusinessPermission = typeof BusinessPermission[keyof typeof BusinessPermission];


export function instanceOfBusinessPermission(value: any): boolean {
    for (const key in BusinessPermission) {
        if (Object.prototype.hasOwnProperty.call(BusinessPermission, key)) {
            if (BusinessPermission[key as keyof typeof BusinessPermission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BusinessPermissionFromJSON(json: any): BusinessPermission {
    return BusinessPermissionFromJSONTyped(json, false);
}

export function BusinessPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessPermission {
    return json as BusinessPermission;
}

export function BusinessPermissionToJSON(value?: BusinessPermission | null): any {
    return value as any;
}

export function BusinessPermissionToJSONTyped(value: any, ignoreDiscriminator: boolean): BusinessPermission {
    return value as BusinessPermission;
}

